//
//
//
//
//
//

import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
export default {
    components: {
        MHeader,
        NotData,
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/Information/Information.vue